import React, { useRef, Fragment, useState } from 'react';
import './Quiz.scss';

function Quiz() {
  const container = useRef();
  const headRef = useRef();

  const [active, setActive] = useState([
    { label: 'Knoxville, TN', active: false, id: 'knoxville' },
    { label: 'Atlanta, GA', active: false, id: 'atlanta' },
    { label: 'Dallas, TX', active: false, id: 'dallas' },
    { label: 'Raleigh, NC', active: false, id: 'raleigh' },
    { label: 'Fayetteville, AK', active: false, id: 'fayetteville' },
    { label: 'Greenville, SC', active: false, id: 'greenville' },
    { label: 'Huntsville, AL', active: false, id: 'huntsville' },
    { label: 'Jacksonville, FL', active: false, id: 'jacksonville' },
    { label: 'Charleston, SC', active: false, id: 'charleston' },
    { label: 'San Antonio, TX', active: false, id: 'sanAntonio' }
  ]);

  const [submit, setSubmit] = useState(false);

  const handleSubmit = () => {
    if (!submit) {
      headRef.current.style.opacity = 0;
      setTimeout(() => {
        setSubmit(true);
        headRef.current.style.opacity = 1;
      }, [500]);
    }
  };

  const handleActive = (i) => {
    const temp = [...active];
    if (!active[i].active) {
      temp[i].active = true;
      setActive(temp);
    } else {
      temp[i].active = false;
    }
    setActive(temp);
  };
  return (
    <figure className="quiz" ref={container}>
      <div className="quiz-container">
        {submit ? (
          <p className="quiz__answer" ref={headRef}>
            According to NAR, <span className="quiz__answer--bold">all</span> of these 10 markets
            have the right combination of housing affordability, job gains, and population growth to
            lead the nation in home price growth in 2023.
          </p>
        ) : (
          <h3 className="quiz__head" ref={headRef}>
            Which of these housing markets are predicted to outperform the national average in 2023?
            Click all that may apply.
          </h3>
        )}

        <div className="quiz__contents">
          {active.map((el, i) => {
            return (
              <Fragment>
                {submit ? (
                  <button className="quiz__button quiz__button--submit">{el.label}</button>
                ) : (
                  <button
                    onClick={() => {
                      handleActive(i);
                    }}
                    className={
                      el.active === true
                        ? 'quiz__button quiz__button--active'
                        : 'quiz__button buttonClick'
                    }
                    id={el.id}
                  >
                    {el.label}
                  </button>
                )}
              </Fragment>
            );
          })}
        </div>
        <button
          className={submit ? 'quiz__submit quiz__submit--active' : 'quiz__submit buttonClick'}
          onClick={handleSubmit}
          id="submit"
        >
          Submit
        </button>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Quiz;
